export default "__VITE_ASSET__CgNHE8G5__"